import React, { useEffect, useState } from 'react';
import api from '../../../services/api';
import {Stack, Step, StepLabel, Stepper, Tooltip, Typography, styled, IconButton as IconButtonMui } from '@mui/material';
import { IconButton, ProgressBar, Text } from 'react-native-paper';
import StepConnector, { stepConnectorClasses } from '@mui/material/StepConnector';
import Team from '../Team';
function Steps({id, idContrato, data, status}) {
    const [stepState, setStepState] = useState(0);
    const [etapa1State, setEtapa1State] = useState("");
    const [etapa2State, setEtapa2State] = useState("");
    const [etapa3State, setEtapa3State] = useState("");
    const [time1State, setTime1State] = useState("");
    const [time2State, setTime2State] = useState("");
    const [time3State, setTime3State] = useState("");
    const [loading, setLoading] = useState(false);
    let verificar;
    useEffect(()=>{
        const load = async (id) => {
            setLoading(true)
            api.get(`/clients/queue/` + id,{
            }).then(function (response) {
                setLoading(false);
                let {data, status} = response.data;
                if(status === true){
                    if(data.length > 0){
                        data.forEach((element) => {
                            switch (element.tipo) {
                                case 0:
                                    setEtapa1State(element.message)
                                    setTime1State(element.time)
                                    setStepState(1);
                                    break;
                                case 1:
                                    setEtapa2State(element.message)
                                    setTime2State(element.time)
                                    setStepState(2);
                                    break;
                                case 2:
                                    setEtapa3State(element.message)
                                    setTime3State(element.time)
                                    setStepState(3);
                                    clearInterval(verificar)
                                    break;
                                default:
                                    break;
                            }
                        });
                    }else{
                        setStepState(0);
                    }
                }
            }).catch(function(error){
                console.log(error)
            });
        }
        setEtapa1State("")
        setTime1State("")
        setStepState(0);
        load(id);
        if(verificar) clearInterval(verificar); 
        // eslint-disable-next-line react-hooks/exhaustive-deps
        verificar=setInterval(function(){
            load(id);
        }, 30000);
        return () => {
            clearInterval(verificar)
        };
    }, [id])
    let labels = ["Saiu","A caminho", "Coletado"];
    const ColorlibConnector = styled(StepConnector)(({ theme }) => ({
        [`&.${stepConnectorClasses.alternativeLabel}`]: {
          top: 30,
        },
        [`&.${stepConnectorClasses.completed}`]: {
          [`& .${stepConnectorClasses.line}`]: {
            backgroundColor: "#39e0b4",
          },
        },
        [`& .${stepConnectorClasses.line}`]: {
          height: 3,
          border: 0,
          backgroundColor:
            theme.palette.mode === 'dark' ? theme.palette.grey[800] : '#eaeaf0',
          borderRadius: 1,
        },
      }));
    const ColorlibStepIconRoot = styled('div')(({ theme, ownerState }) => ({
        backgroundColor: theme.palette.mode === 'dark' ? theme.palette.grey[700] : '#ccc',
        zIndex: 1,
        color: '#fff',
        display: 'flex',
        borderRadius: '50%',
        justifyContent: 'center',
        alignItems: 'center',
        ...(ownerState.completed && {
            backgroundColor: "#39e0b4",
        }),
    }));
    function ColorlibStepIcon(props) {
        const { active, completed, className } = props;
        const icons = {
            1: etapa1State ? (
                <Tooltip title={
                    <Stack direction="column" spacing={0}>
                        <Text style={{color: "#FFF"}}>{etapa1State}</Text>
                        <Text style={{color: "#aaaaaa"}}>{time1State}</Text>
                    </Stack>
                }>
                    <IconButtonMui
                    onClick={()=>{}} >
                        <IconButton 
                        size={34} 
                        selected 
                        iconColor="#FFF"  
                        icon="truck-cargo-container" />
                    </IconButtonMui>
                </Tooltip>
            ) : (
                <IconButton 
                    size={34} 
                    selected 
                    disabled={true}
                    onPress={()=>{}} 
                    iconColor="#aaaaaa"  
                    icon="truck-cargo-container" />
            ),
            2: etapa2State ? (
                <Tooltip title={
                    <Stack direction="column" spacing={0}>
                        <Text style={{color: "#FFF"}}>{etapa2State}</Text>
                        <Text style={{color: "#aaaaaa"}}>{time2State}</Text>
                    </Stack>
                }>
                    <IconButtonMui
                    onClick={()=>{}} >
                        <IconButton 
                        size={34} 
                        selected 
                        iconColor="#FFF"  
                        icon="google-maps" />
                    </IconButtonMui>
                </Tooltip>
            ) : (
                <IconButton 
                    size={34} 
                    selected 
                    disabled={true}
                    onPress={()=>{}} 
                    iconColor="#aaaaaa"  
                    icon="google-maps" />
            ),
          3: etapa3State ? (
            <Tooltip title={
                <Stack direction="column" spacing={0}>
                    <Text style={{color: "#FFF"}}>{etapa3State}</Text>
                    <Text style={{color: "#aaaaaa"}}>{time3State}</Text>
                </Stack>
            }>
                <IconButtonMui
                    onClick={()=>{}} >
                    <IconButton 
                    size={34} 
                    selected 
                    onPress={()=>{}} 
                    iconColor="#FFF"  
                    icon="archive-check" />
                </IconButtonMui>
            </Tooltip>
            ) : (
                <IconButton 
                size={34} 
                selected 
                disabled={true}
                onPress={()=>{}} 
                iconColor="#aaaaaa"  
                icon="archive-check" />
            ),
        };
        return (
          <ColorlibStepIconRoot ownerState={{ completed, active }} className={className}>
            {icons[String(props.icon)]}
          </ColorlibStepIconRoot>
        );
    }
    return (
        <Stack direction="column" spacing={0} style={{width: "100%"}}>
            <Typography gutterBottom variant="body2" component="div" style={{paddingBottom: 20}}>Status da coleta:</Typography>
            <Team id={id} />
            <div style={{width: "100%"}}>
                <Stepper activeStep={stepState}  style={{ width: "100%", marginBottom: 20}} alternativeLabel connector={<ColorlibConnector />} >
                    {labels.map((item, index) => (
                        <Step key={index}>
                            <StepLabel StepIconComponent={ColorlibStepIcon}>{item}</StepLabel>
                        </Step>
                    ))}
                </Stepper>
                {loading && (
                    <ProgressBar indeterminate={true} color="#39e0b4" style={{marginLeft: "13%", marginRight: "13%", marginBottom: 20}} />
                )}
            </div>
            <Typography gutterBottom variant="body2" component="div">
                {id} - {data}
            </Typography>
            <Typography gutterBottom variant="body2" component="div">
                Status: {status}
            </Typography>
        </Stack>
    );
}

export default Steps;